<template>
  <div class="login_info_box">
    <div class="login_info_box_item">
      <div>{{ $t('login.user_name') }}</div>
      <div>
        <el-input :placeholder="$t('login.enter_user_name')" v-model="loginForm.loginName" clearable></el-input>
      </div>
    </div>
    <div class="login_info_box_item">
      <div>{{ $t('login.password') }}</div>
      <div>
        <el-input :placeholder="$t('login.enter_password')" v-model="loginForm.password" show-password
                  @keyup.native.enter="login"></el-input>
      </div>
    </div>
    <div class="login_info_box_item">
      <div style="display: flex;">
        <el-input placeholder="验证码" prefix-icon="el-icon-circle-check" v-model="code"
                  @keyup.enter.native="login"></el-input>
        <Sidentify :identifyCode="identifyCode" @click.native="refreshCode"/>
      </div>
    </div>
    <div class="login_info_box_item">
      <b2b-button @click="login">{{ $t('login.login_btn') }}</b2b-button>
    </div>


    <el-dialog title="温馨提示" :visible.sync="showChangePwdDialog" width="550px"
               :close-on-click-modal="false" append-to-body>
      <div>
          <div style="color: #606266;margin-bottom: 15px">您的密码已超过90天未修改，为了您的安全，请修改密码后重新登录。</div>
          <el-form label-position="top" label-width="100px" :model="form" :rules="rules" ref="passForm">
            <el-form-item label="原密码" prop="oldPwd">
              <el-input v-model="form.oldPwd" type="password" show-password clearable
                        placeholder="请输入原密码"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPwd">
              <el-input v-model="form.newPwd" type="password" show-password clearable
                        placeholder="大小写字母、数字和特殊字符中至少三种类型混合组成，长度8位以上"></el-input>
            </el-form-item>
            <el-form-item label="重复新密码" prop="confirmNewPassword">
              <el-input v-model="form.confirmNewPassword" type="password" show-password clearable
                        placeholder="请再次输入密码"></el-input>
            </el-form-item>
          </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" @click="forceChangePwd">确定修改</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import Sidentify from './sidentify.vue'

export default {
  components: {
    Sidentify
  },
  data () {
    let checkOldPwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入新密码'))
      } else {
        const regexList = [
          /[A-Z]/,          // 大写字母
          /[a-z]/,          // 小写字母
          /\d/,             // 数字
          /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/ // 常用特殊字符
        ]
        if (value.length < 8) {
          return callback(new Error('密码长度不能少于8位'))
        }
        const matchedTypes = regexList.filter(regex => regex.test(value)).length
        if (matchedTypes < 3) {
          return callback(new Error('请输入正确的密码格式'))
        }
        callback();
      }
    }
    let checkNewPwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请重复新密码'))
      } else {
        if (value === this.form.newPwd) {
          callback()
        } else {
          return callback(new Error('两次密码输入不一致'))
        }
      }
    }
    return {
      loginForm: {},
      identifyCode: '',
      identifyCodes: '0123456789',
      code: '',
      showChangePwdDialog: false,
      rules: {
        oldPwd: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPwd: [{ required: true, validator: checkOldPwd, trigger: 'blur' }],
        confirmNewPassword: [{ required: true, validator: checkNewPwd, trigger: 'blur' }]
      },
      form: {},
      userInfo: {}
    }
  },
  created () {
    this.makeCode(4)
  },
  methods: {
    async login () {
      if (!this.loginForm.loginName) return this.$message.warning('请输入用户名')
      if (!this.loginForm.password) return this.$message.warning('请输入密码')
      if (!this.code) return this.$message.warning('请输入验证码')
      if (this.code !== this.identifyCode) return this.$message.warning('验证码错误')
      let pwdErrDate = localStorage.getItem(`${this.loginForm.loginName}_pwdErrDate`)
      let errDate = new Date(pwdErrDate).getTime()
      let nowDate = Date.now()
      if (pwdErrDate && nowDate - errDate < 30 * 60 * 1000) {
        this.$confirm('当前账户处于锁定状态，请在30分钟后再进行登录。如有疑问，请联系系统管理员。', '账户已锁定', {
          showCancelButton: false,
          type: 'warning'
        })
        return
      }
      this.loginForm.device = 'from b2b'
      const {data: result} = await this.$http.post('mini/loginByName', this.loginForm)
      if (result.code !== 200) {
        if (result.message === '密码不正确') {
          this.handleErrPwd()
        }
        return this.$message.error(result.message)
      }
      localStorage.removeItem(`${this.loginForm.loginName}_pwdErrCount`)
      if (result.data.pwdUpdateDate) {
        if (this.isOver90Days(Date.now(), result.data.pwdUpdateDate)) {
          this.userInfo = result.data
          this.showChangePwdDialog = true
          return
        }
      }
      localStorage.setItem('partnerInfo', JSON.stringify(result.data))
      sessionStorage.removeItem('homeSearchForm')
      this.$router.push('/NewHome')
    },
    isOver90Days (time1, time2) {
      // 将输入转换为Date对象
      const date1 = new Date(time1);
      const date2 = new Date(time2);

      // 验证时间有效性
      if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
        throw new Error('传入的时间格式无效')
      }

      // 计算时间差（取绝对值，避免顺序影响）
      const diffMs = Math.abs(date1.getTime() - date2.getTime())
      // 90天对应的毫秒数：90天 * 24小时 * 60分钟 * 60秒 * 1000毫秒
      const ninetyDaysMs = 90 * 24 * 60 * 60 * 1000

      return diffMs > ninetyDaysMs
    },
    forceChangePwd () {
      this.$refs.passForm.validate(async (valid) => {
        if (valid) {
          if (this.userInfo.personType === 1) {
            await this.changePwd()
          } else {
            await this.changeSubPwd()
          }
        }
      })
    },
    async changePwd () {
      let headerReq = {
        accessToken: this.userInfo.token
      }
      let req = {...this.form}
      req.updateWhat = 1
      const { data: result } = await this.$http.post('/mini/uptPartner', req, { headers: headerReq })
      if (result.code !== 200) return this.$message.error(result.message)
      this.$message.success('修改成功')
      this.showChangePwdDialog = false
    },
    async changeSubPwd () {
      let headerReq = {
        accessToken: this.userInfo.token
      }
      let req = {...this.form}
      req.updateWhat = 1
      const { data: result } = await this.$http.post('/mini/uptSubAccount', req, { headers: headerReq })
      if (result.code !== 200) return this.$message.error(result.message)
      this.$message.success('修改成功')
      this.showChangePwdDialog = false
    },
    handleErrPwd () {
      let pwdErrCount = localStorage.getItem(`${this.loginForm.loginName}_pwdErrCount`)
      if (!pwdErrCount || Number(pwdErrCount) === 4) {
        localStorage.setItem(`${this.loginForm.loginName}_pwdErrCount`, 1)
      } else {
        let newPwdErrCount = Number(pwdErrCount) + 1
        localStorage.setItem(`${this.loginForm.loginName}_pwdErrCount`, newPwdErrCount)
        if (Number(newPwdErrCount) === 3) {
          this.$confirm('用户名或密码不正确，您还可以尝试1次。为保证账户安全，连续错误4次将被临时锁定。', '登录失败', {
            showCancelButton: false,
            type: 'warning'
          })
        }
        if (Number(newPwdErrCount) === 4) {
          this.$confirm('您已连续4次输入错误的用户名或密码，账户已被临时锁定30分钟，请稍后再尝试登录。', '账户已锁定', {
            showCancelButton: false,
            type: 'error'
          })
          localStorage.setItem(`${this.loginForm.loginName}_pwdErrDate`, new Date().Format('yyyy-MM-dd hh:mm:ss'));
        }
      }
    },
    refreshCode () {
      this.identifyCode = ''
      this.makeCode(4)
    },
    makeCode (l) {
      let length = this.identifyCodes.length
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[Math.floor(Math.random() * length)]
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login_info_box {
  font-size: 14px;

  .login_info_box_item {
    display: grid;
    grid-auto-rows: auto auto;
    grid-row-gap: 10px;
    margin-bottom: 25px;
  }
}

/deep/ .el-dialog {
  border-radius: 8px;
}

/deep/ .el-dialog__header {
  border-radius: 8px;
  background-color: #fff;
  padding: 10px 20px;
  display: flex;
  align-items: center;
}

/deep/ .el-dialog__title {
  color: #606266;
  font-size: 18px;
  font-weight: 500;
}

/deep/ .el-dialog__body {
  padding: 10px 20px;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  font-size: 18px;
}

/deep/ .el-dialog__headerbtn {
  height: 20px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/login/components/LoginByName.vue